export default __webpack_public_path__ + "static/media/playwatch.3e28543e.svg";